import { render, staticRenderFns } from "./TransferAccountCreateUpdate.vue?vue&type=template&id=44533c5c&scoped=true&"
import script from "./TransferAccountCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./TransferAccountCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TransferAccountCreateUpdate.vue?vue&type=style&index=0&id=44533c5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44533c5c",
  null
  
)

export default component.exports